var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWalkInNoBg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "walk-in-no-bg_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.889.891h22.222v22.222H.889z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#walk-in-no-bg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.37 22.189 9.963 9.133l-1.667.648v3.148H6.444V8.578l4.676-1.991c.216-.093.444-.147.683-.162.24-.016.467.015.683.092.216.078.42.186.613.324.193.14.351.317.475.533l.926 1.481c.401.648.945 1.18 1.632 1.598.687.416 1.47.625 2.35.625v1.851c-1.08 0-2.045-.223-2.894-.67a7.436 7.436 0 0 1-2.176-1.714l-.579 2.847 1.945 1.852v6.945h-1.852V16.17L10.98 14.69l-1.666 7.5H7.37ZM13.39 5.985c-.51 0-.945-.181-1.308-.544a1.783 1.783 0 0 1-.544-1.308c0-.51.181-.945.544-1.308a1.783 1.783 0 0 1 1.308-.544c.51 0 .945.182 1.308.544.362.363.544.799.544 1.308 0 .51-.182.945-.544 1.308a1.783 1.783 0 0 1-1.308.544Z"
}))));
SvgWalkInNoBg.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgWalkInNoBg);
export default ForwardRef;